<template>
  <div>
    <div class="row mb-3">
      <div class="col">
        <h5>{{ _.presenter }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-6">
        <div class="input-group mb-3">
          <input type="text" class="form-control" :placeholder="_.search_default" :aria-label="_.search_default"
                 aria-describedby="basic-addon1" autocomplete="false" v-model="filterAuthor">
          <button class="btn border-top border-bottom" v-on:click="filterAuthor = ''"
                  v-if="filterAuthor.length > 0">
            <icon :icon="['far', 'times']"/>
          </button>
          <span class="input-group-text" id="basic-addon1">
            <icon :icon="['fad', 'magnifying-glass']" class="fa-1x my-auto"/>
          </span>
        </div>
      </div>
    </div>
    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      <template v-for="(author, index) in filteredAuthorList">
        <!--        <div v-if="makeBreak(index)" class="pt-2 pb-2 bg-primary text-bg-primary w-100 d-block fs-5 fw-bold">-->
        <!--          {{ Array.from(index)[0] }}-->
        <!--        </div>-->
        <div class="col" v-bind:key="index">
          <button class="btn w-100 h-100 position-relative" v-on:click="selectAuthor(index)" data-bs-dismiss="offcanvas"
                  v-bind:class="index === selectedAuthorComp ?'btn-success' : 'btn-outline-primary'">
            <div class="row">
              <div class="col col-2 col-lg-3 d-flex my-auto">
                <icon :icon="['fad', 'user']" class="fa-3x my-auto"/>
              </div>
              <div class="col my-auto fs-5 text-start">
                {{ author.lastname }}, {{ author.firstname }}
              </div>
            </div>
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
          {{ author.abstracts.length }}
          <span class="visually-hidden">uploaded poster</span>
          </span>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "GroupSelectionAuthors",
  data: function () {
    return {
      filterAuthor: '',
      lastIndex: null
    }
  },
  computed: {
    ...mapState(['themes', 'selectedRoom']),
    ...mapState('author', ['selectedAuthor', 'authorList']),
    selectedAuthorComp: {
      get() {
        return this.selectedAuthor
      },
      set(id) {
        this.setSelectedAuthor(id);
      }
    },
    filteredAuthorList: function () {
      if (this.filterAuthor === null || this.filterAuthor === '') {
        return this.authorList;
      }
      let keys = Object.keys(this.authorList);
      let filtered = keys.filter(key => key.search(this.filterAuthor.toUpperCase()) >= 0);
      let returnList = {};
      for (const filteredKey of filtered) {
        returnList[filteredKey] = this.authorList[filteredKey];
      }
      return returnList;
    }
  },
  methods: {
    ...mapMutations(['setSelectedView', 'setSelectedRoom']),
    ...mapMutations('author', ['setSelectedAuthor']),
    selectAuthor(author_key) {
      this.setSelectedView('author');
      this.selectedAuthorComp = author_key;
      this.$emit('push');
    },
    makeBreak(key) {
      if (!this.lastIndex) {
        this.lastIndex = key;
        return true;
      }
      if (Array.from(this.lastIndex)[0] === Array.from(key)[0]) {
        return false;
      }
      this.lastIndex = key;
      return true;
    }
  }
}
</script>

<style scoped>

</style>
